import GfbLoginSuccessRedirect from './gfb-login-success-redirect';

export default GfbLoginSuccessRedirect;
